// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notice-board {
  width: 100%;
}

.board-title {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #2c3e50;
  padding-bottom: 10px;
  border-bottom: 2px solid #667eea;
}

.notice-list {
  overflow-x: auto;
}

.notice-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.notice-table thead {
  background-color: #f8f9fa;
}

.notice-table th {
  padding: 12px;
  text-align: left;
  font-weight: 600;
  color: #495057;
  border-bottom: 2px solid #dee2e6;
}

.notice-table tbody tr {
  cursor: pointer;
  transition: background-color 0.2s ease;
  border-bottom: 1px solid #e9ecef;
}

.notice-table tbody tr:hover {
  background-color: #f8f9fa;
}

.notice-table tbody tr.selected {
  background-color: #e7f3ff;
}

.notice-table td {
  padding: 12px;
  color: #495057;
}

.notice-table td.title {
  font-weight: 500;
  color: #2c3e50;
}

.notice-table td.category {
  font-weight: 500;
  color: #667eea;
}

.no-data {
  text-align: center;
  padding: 40px !important;
  color: #6c757d;
  font-size: 16px;
}

@media (max-width: 768px) {
  .notice-table {
    font-size: 12px;
  }
  
  .notice-table th,
  .notice-table td {
    padding: 8px 6px;
  }
  
  .board-title {
    font-size: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/NoticeBoard.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".notice-board {\n  width: 100%;\n}\n\n.board-title {\n  font-size: 24px;\n  font-weight: 600;\n  margin-bottom: 20px;\n  color: #2c3e50;\n  padding-bottom: 10px;\n  border-bottom: 2px solid #667eea;\n}\n\n.notice-list {\n  overflow-x: auto;\n}\n\n.notice-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.notice-table thead {\n  background-color: #f8f9fa;\n}\n\n.notice-table th {\n  padding: 12px;\n  text-align: left;\n  font-weight: 600;\n  color: #495057;\n  border-bottom: 2px solid #dee2e6;\n}\n\n.notice-table tbody tr {\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.notice-table tbody tr:hover {\n  background-color: #f8f9fa;\n}\n\n.notice-table tbody tr.selected {\n  background-color: #e7f3ff;\n}\n\n.notice-table td {\n  padding: 12px;\n  color: #495057;\n}\n\n.notice-table td.title {\n  font-weight: 500;\n  color: #2c3e50;\n}\n\n.notice-table td.category {\n  font-weight: 500;\n  color: #667eea;\n}\n\n.no-data {\n  text-align: center;\n  padding: 40px !important;\n  color: #6c757d;\n  font-size: 16px;\n}\n\n@media (max-width: 768px) {\n  .notice-table {\n    font-size: 12px;\n  }\n  \n  .notice-table th,\n  .notice-table td {\n    padding: 8px 6px;\n  }\n  \n  .board-title {\n    font-size: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
